export interface User {
	id: string;
	email: string;
	firstName?: string;
	lastName?: string;
	phoneNumber: string;
	role?: UserRole;
	birthDate?: string;
}

export enum UserRole {
	ADMIN = 'ADMIN',
	USER = 'USER'
}

export enum AuthType {
	SIGNUP = 'SIGNUP',
	SIGNIN = 'SIGNIN'
}

export interface AuthTokens {
	accessToken: string;
	refreshToken: string;
	expiresIn: number;
}

export interface OTPCredentials {
	email: string;
}

export interface LoginCredentials {
	email: string;
	otp: string;
}

export interface RegisterCredentials {
	firstName: string;
	lastName: string;
	email: string;
	phoneNumber: string;
	birthDate: Date;
	otp?: string;
}

export interface RegisterAdminCredentials {
	name: string;
	login: string;
	email: string;
	password: string;
	verifyPassword: string;
}

export interface AuthState {
	user: User | null;
	isAuthenticated: boolean;
	isLoading: boolean;
	error: string | null;
}

export interface AuthContextType extends AuthState {
	login: (credentials: LoginCredentials) => Promise<void>;
	logout: () => Promise<void>;
	register: (data: RegisterData) => Promise<void>;
	getAccessToken: () => string | null;
	refreshTokens: () => Promise<void>;
}

export interface RegisterData extends LoginCredentials {
	firstName?: string;
	lastName?: string;
}

export interface AuthResponse {
	token: string;
	refreshToken: string;
}

export interface OAuthCredentials {
	code: string;
	redirectUri: string;
}
